import tags from "../../../components/tags";
import { icons } from "../../../components/html";
import { statusCodes } from "../../../components/responses";

export default {
  "/client/active-size-charts": {
    get: {
      tags: [tags.businessAccount],
      summary: "List of active size charts",
      description: `${icons.c}
      Returns list of active size charts, which corresponds with selected filtration.`,
      parameters: [
        { $ref: "#/components/parameters/acceptsLanguages" },
        { $ref: "#/components/parameters/brand" },
        { $ref: "#/components/parameters/type" },
        { $ref: "#/components/parameters/gender" },
        { $ref: "#/components/parameters/category" },
        { $ref: "#/components/parameters/limit" },
        { $ref: "#/components/parameters/offset" }
      ],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  id: {
                    type: "integer",
                    description: "unique identifier of table",
                    example: 25
                  },
                  brand: {
                    type: "string",
                    description: "clothing brand",
                    example: "Adidas"
                  },
                  type: {
                    type: "string",
                    description: "localized kind of clothes",
                    example: "Sportovní, vycházková obuv"
                  },
                  gender: {
                    $ref: "#/components/schemas/gender"
                  },
                  categories: {
                    $ref: "#/components/schemas/category"
                  },
                  labels: {
                    $ref: "#/components/schemas/tableMarking"
                  },
                  measures: {
                    $ref: "#/components/schemas/measures"
                  }
                }
              }
            }
          }
        },
        ...statusCodes
      }
    }
  }
};
